module.exports = __webpack_public_path__ + "resources/images/studentenkaart-cd346c16890a19c2350719d53c7c31fc-cache.png";